import * as Sentry from '@sentry/browser';
import {Scope, Event, EventHint} from '@sentry/types';
import {Visitor} from '@stripe-internal/conversations-shared-dependencies';

export const configureSentry = (
  dsn: string,
  release: string,
  visitor: Visitor,
) => {
  Sentry.init({
    dsn,
    release,
    environment: process.env.NODE_ENV,
    // Sentry has a bunch of integrations on by default:
    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/

    // https://docs.sentry.io/platforms/javascript/configuration/options/#initial-scope
    // https://docs.sentry.io/platforms/javascript/enriching-events/identify-user/
    initialScope: (scope: Scope): Scope => {
      if (visitor.sessionType !== 'anonymous') {
        scope.setUser({
          // Sentry calls out id as a specific value so it makes sense to me
          // that we provide the token as the ID. I'm also leaving it set
          // separately as our token value for consistency with our old Sentry
          // reporting code.
          id: visitor.id,
          token: visitor.id,

          // Per the "Identify Users" docs:
          // > If the user's ip_address is set to "{{auto}}", Sentry will infer
          // > the IP address from the connection between your app and Sentry's
          // > server.
          ip_address: '{{auto}}',
        });
      }
      return scope;
    },
    beforeSend: beforeSendFilter,
  });
};

export function beforeSendFilter(event: Event, hint: EventHint) {
  const error = hint.originalException;
  if (error instanceof Error) {
    // Filter out common network errors that don't need to be reported
    if (
      error.message.match(
        /Failed to fetch|Load failed|NetworkError when attempting to fetch resource/i,
      )
    ) {
      return null;
    }
  }
  return event;
}
